import { lazy } from 'react';

// Lazy load layouts
const lazyLoadLayout = (layoutName) => lazy(() =>
    import('layouts').then(module => ({ default: module[layoutName] }))
);

const AuthLayout = lazyLoadLayout('AuthLayout');

// lazy-loaded Pages
const lazyLoad = (moduleName) =>
    lazy(() =>
        import("pages").then((module) => ({ default: module[moduleName] }))
    );

const Home = lazyLoad("Home");
const AllSports = lazyLoad("AllSports");
const AllCasino = lazyLoad("AllCasino");
const Celebrity = lazyLoad("Celebrity");
const TopWinner = lazyLoad("TopWinner");



// creating route objects
const createRoute = (path, element, isPrivate = false) => ({ path, element, isPrivate });

export const routeConfigs = [
    {
        layout: AuthLayout,
        children: [
            createRoute('/', Home, false),
            createRoute('/all-sports', AllSports, false),
            createRoute('/all-casino', AllCasino, false),
            createRoute('/celebrity', Celebrity, false),
            createRoute('/top-winners', TopWinner, false),
        ],
    },

];

